import {Tooltip} from 'platform/components';
import {Box, HStack, Icon, Space, Text} from 'platform/foundation';
import {css} from 'styled-components';

import {isNilOrEmpty} from 'ramda-adjunct';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

type Data = {
  label: string;
  value: number | string | Nullish;
  labelTooltip?: string | Nullish;
  colorCode?: string;
};

export type DataColumnProps = {
  data: Data[];
};

export const DataColumn = (props: DataColumnProps) => (
  <>
    {props.data.map(({label, value, colorCode, labelTooltip}) => {
      if (isNilOrEmpty(value)) {
        return null;
      }
      return (
        <Box key={label + value} paddingVertical={2}>
          <HStack key={label + value}>
            <Box flex={1}>
              <HStack align="center" spacing={1}>
                <Text size="small" color="secondary">
                  {label}
                </Text>
                {labelTooltip && (
                  <Tooltip label={labelTooltip}>
                    <Icon value="action/info" size={4} color="text.tertiary" />
                  </Tooltip>
                )}
              </HStack>
            </Box>
            <Box flex={1}>
              <HStack height="100%" align="center">
                {colorCode && (
                  <>
                    <div
                      css={css`
                        border-radius: ${({theme}) => theme.radii.medium};
                        border: 1px solid ${({theme}) => theme.colors.palettes.neutral[40][100]};
                        background-color: ${colorCode};
                        width: ${({theme}) => theme.getSize(4)};
                        height: ${({theme}) => theme.getSize(4)};
                      `}
                    />
                    <Space horizontal={2} />
                  </>
                )}
                <Text alternative size="small">
                  {String(value ?? EMPTY_PLACEHOLDER)}
                </Text>
              </HStack>
            </Box>
          </HStack>
        </Box>
      );
    })}
  </>
);
